var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"404"},[_c('Header',{attrs:{"env":_vm.env}}),_c('ComponentNotFound')],1)}
var staticRenderFns = []

export { render, staticRenderFns }